var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"its-auto-fit"},[_c('mobile-header'),_c('div',{staticClass:"ho-mobile-page"},[_c('router-view'),(!_vm.$route.meta.hiddenFooter)?_c('mobile-footer'):_vm._e()],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }